import { FC, useState, useEffect } from 'react';
import {
  Box,
  Typography,
  Chip,
  SxProps,
} from '@mui/material';

import { CommitmentType } from '@libs/types';
import { useSearch, SEARCH_PARAM_COMMITMENT } from '@carcareers/contexts';

interface JobSearchCommitmentInputProps {
  sx?: SxProps;
}

const COMMITMENT_OPTIONS = [
  { value: 'any', label: 'Any' },
  { value: CommitmentType.FULL_TIME, label: 'Full-time' },
  { value: CommitmentType.PART_TIME, label: 'Part-time' },
  { value: CommitmentType.CONTRACT, label: 'Contract' },
  { value: CommitmentType.TEMPORARY, label: 'Temporary' },
  { value: CommitmentType.INTERNSHIP, label: 'Internship' },
];

export const JobSearchCommitmentInput: FC<JobSearchCommitmentInputProps> = ({ sx }) => {
  const { commitment: commitmentContext, updateSearchParams } = useSearch();
  
  const [selectedCommitment, setSelectedCommitment] = useState<string>(
    commitmentContext || 'any'
  );

  const handleCommitmentChange = (value: string) => () => {
    setSelectedCommitment(value);
    updateSearchParams(SEARCH_PARAM_COMMITMENT, value === 'any' ? undefined : value);
  };

  useEffect(() => {
    const contextValue = commitmentContext || 'any';
    if (contextValue !== selectedCommitment) {
      setSelectedCommitment(contextValue);
    }
  }, [commitmentContext]);

  return (
    <Box sx={{ width: '100%', ...sx }}>
      <Typography variant="h6" gutterBottom>Job Type</Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {COMMITMENT_OPTIONS.map((option) => (
          <Chip
            key={option.value}
            label={option.label}
            onClick={handleCommitmentChange(option.value)}
            color={selectedCommitment === option.value ? 'primary' : 'default'}
            variant={selectedCommitment === option.value ? 'filled' : 'outlined'}
            sx={{ mb: 1 }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default JobSearchCommitmentInput;
